import React from "react";
import { Alert, Box, Button, CircularProgress, Skeleton, Stack, Typography } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";

export function LoadingState({ rows = 4, label = "Loading" }) {
  return <Stack aria-label={label} spacing={1.25} sx={{ py: 1 }}>{Array.from({ length: rows }, (_, index) => <Skeleton key={index} variant="rounded" height={index === 0 ? 44 : 56} />)}</Stack>;
}

export function EmptyState({ title = "Nothing here yet", description, action }) {
  return <Box sx={{ py: { xs: 3.5, sm: 4.5 }, px: 2, textAlign: "center" }}><Box sx={{ width: 44, height: 44, borderRadius: "50%", bgcolor: "#eef2ff", color: "primary.main", display: "grid", placeItems: "center", mx: "auto", mb: 1 }}><InboxOutlinedIcon /></Box><Typography variant="h6">{title}</Typography>{description && <Typography color="text.secondary" sx={{ mt: .35, mb: action ? 1.5 : 0 }}>{description}</Typography>}{action}</Box>;
}

export function ErrorState({ message = "Something went wrong.", onRetry }) {
  return <Alert severity="error" action={onRetry ? <Button color="inherit" onClick={onRetry}>Retry</Button> : null}>{message}</Alert>;
}

export function PageLoadingState() {
  return <Box sx={{ minHeight: 300, display: "grid", placeItems: "center" }}><Stack alignItems="center" spacing={1.5}><CircularProgress size={32} /><Typography color="text.secondary">Loading workspace…</Typography></Stack></Box>;
}
